// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Stepssection-eh-split-section-MLF5M {
  width: 100%;
  background: #ffffff;
  padding: 40px 24px 64px;
}

.Stepssection-eh-split-section__container-S2HV1 {
  padding: 0px 60px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  gap: 32px;
  -webkit-box-align: stretch;
      -ms-flex-align: stretch;
          align-items: stretch;
}

/* ================= LEFT: Steps Card ================= */

.Stepssection-eh-steps-card-lVS6b {
  background: #ffffff;
  border: 1px solid #009cff;
  border-radius: 19px;
  padding: 42px 36px 36px;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-box-shadow: 0 4px 20px rgba(0, 156, 255, 0.05);
          box-shadow: 0 4px 20px rgba(0, 156, 255, 0.05);
}

.Stepssection-eh-steps-card__heading-lna20 {
  font-size: 34px;
  font-weight: 700;
  color: #003453;
  text-align: center;
  margin: 0 0 36px 0;
  line-height: 1.2;
}

.Stepssection-eh-steps-list-yt2Xe {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 32px;
  position: relative;
  z-index: 2;
}

.Stepssection-eh-step-item-XoCeA {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 20px;
}

.Stepssection-eh-step-item__icon-wrapper-uHEGr {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 78px;
  height: 78px;
  border-radius: 50%;
  background: rgba(0, 201, 135, 0.2);
  border: 1px solid #ffffff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.Stepssection-eh-step-item__content-YB95Z {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  min-height: 78px;
}

.Stepssection-eh-step-item__header-Fa5Yo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
}

.Stepssection-eh-step-item__number-H9j_f {
  color: #00c987;
  font-weight: 700;
  font-size: 40px;
  line-height: 1;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.Stepssection-eh-step-item__title-M_NdV {
  font-size: 24px;
  font-weight: 700;
  color: #003453;
  margin: 0;
  line-height: 1.2;
}

.Stepssection-eh-step-item__desc-gr7dg {
  font-size: 16.5px;
  line-height: 1.45;
  color: #003453;
  margin: 8px 0 0 0;
  font-weight: 400;
}

.Stepssection-eh-steps-card__mascot-cJhjD {
  position: absolute;
  bottom: 8px;
  left: 18px;
  width: 142px;
  height: auto;
  pointer-events: none;
  z-index: 1;
}

.Stepssection-eh-steps-card__mascot-img-vwPaK {
  width: 100%;
  height: auto;
  -o-object-fit: contain;
     object-fit: contain;
}

/* ================= RIGHT: Calculator Card ================= */

.Stepssection-eh-calc-card-SOSqP {
  background: rgba(0, 201, 135, 0.1);
  border: 1px solid #00c987;
  border-radius: 19px;
  padding: 42px 36px 36px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

.Stepssection-eh-calc-card__heading-RaUNm {
  font-size: 34px;
  font-weight: 700;
  color: #003453;
  text-align: center;
  margin: 0 0 32px 0;
  line-height: 1.2;
}

.Stepssection-eh-calc-form-QItKz {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 20px;
}

.Stepssection-eh-calc-field-kyhcC {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 8px;
}

.Stepssection-eh-calc-label-xfix9 {
  font-size: 22px;
  font-weight: 700;
  color: #003453;
  margin: 0;
  line-height: 1.2;
}

.Stepssection-eh-select-wrapper-t8x5j {
  position: relative;
  width: 100%;
}

.Stepssection-eh-select-YfG3V {
  background-image: none !important;
  width: 100%;
  height: 54px;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  background: #ffffff;
  border: 1px solid #00c987;
  border-radius: 19px;
  padding: 0 44px 0 20px;
  font-size: 16.5px;
  font-weight: 600;
  color: #003453;
  cursor: pointer;
  outline: none;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-transition: border-color 0.2s ease;
  transition: border-color 0.2s ease;
}

.Stepssection-eh-select-YfG3V:focus {
  border-color: #00a86f;
}

.Stepssection-eh-select-arrow-GrIPa {
  position: absolute;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
          transform: translateY(-50%);
  pointer-events: none;
  color: #003453;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.Stepssection-eh-stepper-Icnnf {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  background: #ffffff;
  border: 1px solid #00c987;
  border-radius: 19px;
  height: 54px;
  padding: 0;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  overflow: hidden;
}

.Stepssection-eh-stepper__value-hZWtS {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  text-align: left;
  padding-left: 20px;
  font-size: 16.5px;
  font-weight: 600;
  color: #003453;
}

.Stepssection-eh-stepper__controls-SMiWe {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 100%;
}

.Stepssection-eh-stepper__btn-M52BJ {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 54px;
  height: 54px;
  border-radius: 19px;
  border: 1px solid #00c987 !important;
  background: #ffffff;
  color: #003453;
  font-size: 24px;
  font-weight: 400;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  cursor: pointer;
  margin-right: -1px;
  margin-top: -1px;
  margin-bottom: -1px;
  -webkit-transition: background 0.15s ease, border-color 0.15s ease;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.Stepssection-eh-stepper__btn-M52BJ:hover {
  background: rgba(0, 201, 135, 0.15);
}

.Stepssection-eh-calc-result-G0UfT {
  background: #ffffff;
  border: 1px solid #00c987;
  border-radius: 19px;
  padding: 24px 20px;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin-top: 6px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

.Stepssection-eh-calc-result__label-V5N4O {
  font-size: 22px;
  font-weight: 700;
  color: #003453;
  margin-bottom: 8px;
  line-height: 1.2;
}

.Stepssection-eh-calc-result__amount-Ax5dc {
  font-size: 44px;
  font-weight: 700;
  color: #009cff;
  letter-spacing: -0.5px;
  line-height: 1.1;
}

.Stepssection-eh-calc-disclaimer-Of5ml {
  font-size: 14.5px;
  color: #003453;
  text-align: center;
  margin: 12px 0 0 0;
  font-weight: 400;
  line-height: 1.4;
}

@media (max-width: 900px) {
  .Stepssection-eh-split-section__container-S2HV1 {
    grid-template-columns: 1fr;
    padding: 0 8px;
  }
}

@media (max-width: 600px) {
  .Stepssection-eh-steps-card-lVS6b {
    padding: 28px 18px 28px;
  }

  .Stepssection-eh-steps-card__heading-lna20 {
    font-size: 26px;
    margin-bottom: 24px;
  }

  .Stepssection-eh-step-item-XoCeA {
    gap: 14px;
  }

  .Stepssection-eh-step-item__icon-wrapper-uHEGr {
    width: 60px;
    height: 60px;
  }

  .Stepssection-eh-step-item__icon-wrapper-uHEGr svg {
    width: 26px;
    height: 26px;
  }

  .Stepssection-eh-step-item__content-YB95Z {
    min-height: 60px;
  }

  .Stepssection-eh-step-item__number-H9j_f {
    font-size: 30px;
  }

  .Stepssection-eh-step-item__title-M_NdV {
    font-size: 19px;
  }

  .Stepssection-eh-step-item__desc-gr7dg {
    font-size: 14px;
  }

  .Stepssection-eh-steps-card__mascot-cJhjD {
    width: 100px;
    left: 10px;
    bottom: 6px;
  }

  .Stepssection-eh-calc-card-SOSqP {
    padding: 28px 18px 28px;
  }

  .Stepssection-eh-calc-card__heading-RaUNm {
    font-size: 26px;
    margin-bottom: 24px;
  }

  .Stepssection-eh-calc-label-xfix9 {
    font-size: 19px;
  }

  .Stepssection-eh-calc-result__label-V5N4O {
    font-size: 19px;
  }

  .Stepssection-eh-calc-result__amount-Ax5dc {
    font-size: 36px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WhyhostView/Stepssection.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,0BAAoB;MAApB,uBAAoB;UAApB,oBAAoB;AACtB;;AAEA,yDAAyD;;AACzD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,8BAAsB;UAAtB,sBAAsB;EACtB,sDAA8C;UAA9C,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;EACzB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA,+DAA+D;;AAC/D;EACE,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,8BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,qBAAgB;OAAhB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAAsB;UAAtB,sBAAsB;EACtB,0CAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;EACd,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,8BAAsB;UAAtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kEAA0D;EAA1D,0DAA0D;AAC5D;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,eAAe;EACf,8BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".eh-split-section {\n  width: 100%;\n  background: #ffffff;\n  padding: 40px 24px 64px;\n}\n\n.eh-split-section__container {\n  padding: 0px 60px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1.15fr 0.85fr;\n  gap: 32px;\n  align-items: stretch;\n}\n\n/* ================= LEFT: Steps Card ================= */\n.eh-steps-card {\n  background: #ffffff;\n  border: 1px solid #009cff;\n  border-radius: 19px;\n  padding: 42px 36px 36px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  box-shadow: 0 4px 20px rgba(0, 156, 255, 0.05);\n}\n\n.eh-steps-card__heading {\n  font-size: 34px;\n  font-weight: 700;\n  color: #003453;\n  text-align: center;\n  margin: 0 0 36px 0;\n  line-height: 1.2;\n}\n\n.eh-steps-list {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  position: relative;\n  z-index: 2;\n}\n\n.eh-step-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.eh-step-item__icon-wrapper {\n  box-sizing: border-box;\n  width: 78px;\n  height: 78px;\n  border-radius: 50%;\n  background: rgba(0, 201, 135, 0.2);\n  border: 1px solid #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.eh-step-item__content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 78px;\n}\n\n.eh-step-item__header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.eh-step-item__number {\n  color: #00c987;\n  font-weight: 700;\n  font-size: 40px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n}\n\n.eh-step-item__title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #003453;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.eh-step-item__desc {\n  font-size: 16.5px;\n  line-height: 1.45;\n  color: #003453;\n  margin: 8px 0 0 0;\n  font-weight: 400;\n}\n\n.eh-steps-card__mascot {\n  position: absolute;\n  bottom: 8px;\n  left: 18px;\n  width: 142px;\n  height: auto;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.eh-steps-card__mascot-img {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n/* ================= RIGHT: Calculator Card ================= */\n.eh-calc-card {\n  background: rgba(0, 201, 135, 0.1);\n  border: 1px solid #00c987;\n  border-radius: 19px;\n  padding: 42px 36px 36px;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.eh-calc-card__heading {\n  font-size: 34px;\n  font-weight: 700;\n  color: #003453;\n  text-align: center;\n  margin: 0 0 32px 0;\n  line-height: 1.2;\n}\n\n.eh-calc-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.eh-calc-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.eh-calc-label {\n  font-size: 22px;\n  font-weight: 700;\n  color: #003453;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.eh-select-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.eh-select {\n  background-image: none !important;\n  width: 100%;\n  height: 54px;\n  appearance: none;\n  -webkit-appearance: none;\n  background: #ffffff;\n  border: 1px solid #00c987;\n  border-radius: 19px;\n  padding: 0 44px 0 20px;\n  font-size: 16.5px;\n  font-weight: 600;\n  color: #003453;\n  cursor: pointer;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease;\n}\n\n.eh-select:focus {\n  border-color: #00a86f;\n}\n\n.eh-select-arrow {\n  position: absolute;\n  right: 18px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: #003453;\n  display: flex;\n  align-items: center;\n}\n\n.eh-stepper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #ffffff;\n  border: 1px solid #00c987;\n  border-radius: 19px;\n  height: 54px;\n  padding: 0;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.eh-stepper__value {\n  flex: 1;\n  text-align: left;\n  padding-left: 20px;\n  font-size: 16.5px;\n  font-weight: 600;\n  color: #003453;\n}\n\n.eh-stepper__controls {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n.eh-stepper__btn {\n  box-sizing: border-box;\n  width: 54px;\n  height: 54px;\n  border-radius: 19px;\n  border: 1px solid #00c987 !important;\n  background: #ffffff;\n  color: #003453;\n  font-size: 24px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-right: -1px;\n  margin-top: -1px;\n  margin-bottom: -1px;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.eh-stepper__btn:hover {\n  background: rgba(0, 201, 135, 0.15);\n}\n\n.eh-calc-result {\n  background: #ffffff;\n  border: 1px solid #00c987;\n  border-radius: 19px;\n  padding: 24px 20px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 6px;\n  box-sizing: border-box;\n}\n\n.eh-calc-result__label {\n  font-size: 22px;\n  font-weight: 700;\n  color: #003453;\n  margin-bottom: 8px;\n  line-height: 1.2;\n}\n\n.eh-calc-result__amount {\n  font-size: 44px;\n  font-weight: 700;\n  color: #009cff;\n  letter-spacing: -0.5px;\n  line-height: 1.1;\n}\n\n.eh-calc-disclaimer {\n  font-size: 14.5px;\n  color: #003453;\n  text-align: center;\n  margin: 12px 0 0 0;\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n@media (max-width: 900px) {\n  .eh-split-section__container {\n    grid-template-columns: 1fr;\n    padding: 0 8px;\n  }\n}\n\n@media (max-width: 600px) {\n  .eh-steps-card {\n    padding: 28px 18px 28px;\n  }\n\n  .eh-steps-card__heading {\n    font-size: 26px;\n    margin-bottom: 24px;\n  }\n\n  .eh-step-item {\n    gap: 14px;\n  }\n\n  .eh-step-item__icon-wrapper {\n    width: 60px;\n    height: 60px;\n  }\n\n  .eh-step-item__icon-wrapper svg {\n    width: 26px;\n    height: 26px;\n  }\n\n  .eh-step-item__content {\n    min-height: 60px;\n  }\n\n  .eh-step-item__number {\n    font-size: 30px;\n  }\n\n  .eh-step-item__title {\n    font-size: 19px;\n  }\n\n  .eh-step-item__desc {\n    font-size: 14px;\n  }\n\n  .eh-steps-card__mascot {\n    width: 100px;\n    left: 10px;\n    bottom: 6px;\n  }\n\n  .eh-calc-card {\n    padding: 28px 18px 28px;\n  }\n\n  .eh-calc-card__heading {\n    font-size: 26px;\n    margin-bottom: 24px;\n  }\n\n  .eh-calc-label {\n    font-size: 19px;\n  }\n\n  .eh-calc-result__label {\n    font-size: 19px;\n  }\n\n  .eh-calc-result__amount {\n    font-size: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eh-split-section": `Stepssection-eh-split-section-MLF5M`,
	"eh-split-section__container": `Stepssection-eh-split-section__container-S2HV1`,
	"eh-steps-card": `Stepssection-eh-steps-card-lVS6b`,
	"eh-steps-card__heading": `Stepssection-eh-steps-card__heading-lna20`,
	"eh-steps-list": `Stepssection-eh-steps-list-yt2Xe`,
	"eh-step-item": `Stepssection-eh-step-item-XoCeA`,
	"eh-step-item__icon-wrapper": `Stepssection-eh-step-item__icon-wrapper-uHEGr`,
	"eh-step-item__content": `Stepssection-eh-step-item__content-YB95Z`,
	"eh-step-item__header": `Stepssection-eh-step-item__header-Fa5Yo`,
	"eh-step-item__number": `Stepssection-eh-step-item__number-H9j_f`,
	"eh-step-item__title": `Stepssection-eh-step-item__title-M_NdV`,
	"eh-step-item__desc": `Stepssection-eh-step-item__desc-gr7dg`,
	"eh-steps-card__mascot": `Stepssection-eh-steps-card__mascot-cJhjD`,
	"eh-steps-card__mascot-img": `Stepssection-eh-steps-card__mascot-img-vwPaK`,
	"eh-calc-card": `Stepssection-eh-calc-card-SOSqP`,
	"eh-calc-card__heading": `Stepssection-eh-calc-card__heading-RaUNm`,
	"eh-calc-form": `Stepssection-eh-calc-form-QItKz`,
	"eh-calc-field": `Stepssection-eh-calc-field-kyhcC`,
	"eh-calc-label": `Stepssection-eh-calc-label-xfix9`,
	"eh-select-wrapper": `Stepssection-eh-select-wrapper-t8x5j`,
	"eh-select": `Stepssection-eh-select-YfG3V`,
	"eh-select-arrow": `Stepssection-eh-select-arrow-GrIPa`,
	"eh-stepper": `Stepssection-eh-stepper-Icnnf`,
	"eh-stepper__value": `Stepssection-eh-stepper__value-hZWtS`,
	"eh-stepper__controls": `Stepssection-eh-stepper__controls-SMiWe`,
	"eh-stepper__btn": `Stepssection-eh-stepper__btn-M52BJ`,
	"eh-calc-result": `Stepssection-eh-calc-result-G0UfT`,
	"eh-calc-result__label": `Stepssection-eh-calc-result__label-V5N4O`,
	"eh-calc-result__amount": `Stepssection-eh-calc-result__amount-Ax5dc`,
	"eh-calc-disclaimer": `Stepssection-eh-calc-disclaimer-Of5ml`
};
module.exports = ___CSS_LOADER_EXPORT___;
